import { useLocation, useNavigate, useParams } from "react-router-dom";
import Company from "./Company";
import GroupUserPermission from "./GroupUserPermission";
import ManageAccess from "./ManageAccess";
import BoardingAdvancedCompany from "./BoardingAdvancedCompany";

export const TabNavigation = ({ activeTab, setActiveTab, refetch, setRefetch, handleCloseDrawer }) => {
  const location = useLocation();
  const { subset } = useParams();

  const params = location.pathname.split("/");

  const tabs = [
    { label: "General Info", isActive: true, path: "general-info" },
    { label: "Advanced Info", isActive: false, path: "advanced-info" },
    { label: "Group or Users Permission", isActive: false, path: "group-or-users-permission" },
    { label: "Manage Access", isActive: false, path: "manage-access" },
  ];

  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    const parts = location.pathname.split("/");
    parts[parts.length - 1] = tab.path; // replace last segment
    const newPath = parts.join("/");
    navigate(newPath);
  };
  // const handleTabClick = (tab) => {

  //   // setActiveTab(tab);
  //   // if (params[1]?.includes("customize")) {
  //   //   navigate(`/setting/?tab=${tab.id}`);
  //   // } else {
  //   //   navigate(`/onboard_company?tab=${tab.id}`);
  //   // }
  //   // if (activeTab !== tab) handleCloseDrawer();
  // };

  return (
    <>
      <div className="flex flex-col w-full h-full">
        <div className="flex flex-col mt-8 w-full max-md:mr-2.5 max-md:max-w-full">
          <nav
            className="flex flex-wrap gap-10 items-center self-start text-base font-medium tracking-wide leading-none text-neutral-500 max-md:max-w-full"
            role="tablist"
          >
            {tabs.map((tab, index) => (
              <button
                key={tab.label}
                type="button"
                role="tab"
                aria-selected={tab.path === subset}
                className={`
              p-3 transition-colors duration-150
              ${tab.path === subset ? "font-bold text-primary border-b-2 border-primary" : "hover:text-primary-90"}
              outline-none focus-visible:ring-2 focus-visible:ring-cyan-400
              `}
                onClick={() => handleTabClick(tab)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
          <div className="w-full border-b border-gray-200" />
        </div>
        <div className="pt-2 pl-2 w-full grow min-h-0">
          {subset === "general-info" ? (
            <Company refetch={refetch} />
          ) : subset === "advanced-info" ? (
            <BoardingAdvancedCompany refetch={refetch} />
          ) : subset === "group-or-users-permission" ? (
            <GroupUserPermission refetch={refetch} setRefetch={setRefetch} />
          ) : (
            <ManageAccess refetch={refetch} />
          )}
        </div>
      </div>
    </>
  );
};
